/* UI */
import { Box, Card } from '@auviknetworks/iceberg-ui';
import { Typography } from '@mui/material';

/* Hooks */
import { useSession } from 'hooks/redux/Selectors/session';

/* React */
import React from 'react';
import { useTranslation } from 'react-i18next';

/**
 * UserGreeting component that displays a personalized greeting card with user information.
 * @returns {JSX.Element} A card containing user avatar, time-based greeting (morning, afternoon, evening) greeting, and email.
 */
export const UserGreeting = () => {
    const { t } = useTranslation();
    const session = useSession();
    const { firstName, email } = session?.user || {};
    const hrs = new Date().getHours();
    const isFirstNameSameAsEmail = firstName === email;
    const displayName = isFirstNameSameAsEmail
        ? firstName?.toLowerCase()
        : firstName;

    let greeting;
    if (hrs < 12) {
        greeting = displayName
            ? t('Common.greetingMorningWithName', { name: displayName })
            : t('Common.greetingMorning');
    } else if (hrs >= 12 && hrs <= 17) {
        greeting = displayName
            ? t('Common.greetingAfternoonWithName', { name: displayName })
            : t('Common.greetingAfternoon');
    } else {
        greeting = displayName
            ? t('Common.greetingEveningWithName', { name: displayName })
            : t('Common.greetingEvening');
    }

    return (
        <Card sx={{ padding: '16px' }}>
            <Box>
                <Typography variant="h6" sx={{ textTransform: 'none' }}>
                    {greeting}
                </Typography>
                {!isFirstNameSameAsEmail && (
                    <Typography variant="caption">{email}</Typography>
                )}
            </Box>
        </Card>
    );
};
